import GroupsDeleteModalView from "./GroupsDeleteModal.html";
import PositionModalView from "./PositionModal.html";
import GroupGroupModalView from "./GroupGroupModal.html";
import HistoricModalView from "./HistoricModal.html";
import GroupContactModalView from "./GroupContactModal.html";
import GroupAddressModalView from "./GroupAddressModal.html";
import ExtendPositionsModalView from "./ExtendPositionsModal.html";
import AttendedEventsModalView from "./AttendedEventsModal.html";
import InstitutionEditModalView from "../institutions/InstitutionEditModal.html";
import PositionMailModalView from "./PositionMailModal.html";
import PositionAddressModalView from "./PositionAddressModal.html";
import PositionContactModalView from "./PositionContactModal.html";
import EndPositionAndAddNewPositionView from "./EndPositionAndAddNewPosition.html";
import SearchPersonsModalView from "./searchPersonsModal.html";
import SearchGroupModalView from "../events/guests/searchGroupModal.html";



import toastr from 'toastr';


angular.module("groups")

    .controller("GroupsEditCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', '$translate', 'treeService', '$q', '$http', 'uiGridConstants', '$timeout','datasetsService', 'logService',
        function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter, $translate, treeService, $q, $http, uiGridConstants, $timeout, datasetsService, logService) {
        
    //Comprobamos si tiene permiso escritura
    $scope.allowWrite = LoginService.permissionExist("GROUPS_WRITE");
    $scope.allowDeleteDescendants = LoginService.permissionExist("GROUPS_DESCENDANTS_DELETE");
    $scope.canManageEntityAcl = function (acl) {
        return LoginService.aclEnabled() && LoginService.permissionExist("ACL_MANAGE") && LoginService.userCanManageAcl(acl);
    };

    $rootScope.title = $filter('translate')('groups.title');

    $scope.group_id = $stateParams.id;
    $scope.buttonCancel = true;
    $scope.changesNotSaved = false;
    $scope.aclUsers = [];
    $scope.aclGroups = [];
    $scope.aclOptionsLoaded = false;
    $scope.aclDialogState = { visible: false, savedVersion: 0 };

    $scope.group = {
        FK_groups_groups_groups1: []
    };

    $scope.search = {};
    $scope.showPositions = true;
    $scope.hasSearched = false;

    $scope.prepareTitle = function () {
        Restangular.all('Groups').customGET("GetGroupRoute", { group_id: $scope.group_id }).then(function (results) {
            if (results) {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('groups.title'), url: "groups.list" },
                ];
                angular.forEach(results, function (data) {
                    $rootScope.breadcrumb.push({ title: data.fullname, url: "groups.edit({ id: " + data.id + " })" });
                });               
            }
        });
    };

    $scope.groupOptions = function (getGroupId, fromView, callbackClose) {
        if (angular.isDefined(getGroupId) && getGroupId != null) {
            $scope.group_id = getGroupId();
            $scope.fromView = fromView;
        } else {
            $scope.group_id = "";
        }
        $scope.callbackClose = callbackClose;
        $scope.buttonCancel = false;
        $scope.comeFromPersons = true;
        $scope.configure();
    };

    $scope.configure = function () {
        if (angular.isUndefined($scope.group_id) || $scope.group_id == "") {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('groups.title'), url: "groups.list" },
                { title: $filter('translate')('groups.add') }
            ];
            $scope.group.FK_positions_groups = [];
            $scope.group.FK_groups_groups_groups1 = [];
            $scope.group.FK_groups_contacts_groups = [];
            $scope.group.FK_groups_addresses_groups = [];
            // Si creamos un grupo nuevo, le pasamos el group_type
            $scope.group.group_type = $stateParams.group_type;

            // LOGS
            logService.debug($scope.group.group_type);
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('groups.title'), url: "groups.list" },
                { title: $filter('translate')('groups.title_edit') },
            ];
            Restangular.one('Groups', $scope.group_id).get().then(function (results) {
                $scope.group = results;
                $scope.gridListPosition.data = $scope.group.FK_positions_groups;
                $scope.gridGroupContactInfo.data = $scope.group.FK_groups_contacts_groups;
                $scope.gridGroupAddresses.data = $scope.group.FK_groups_addresses_groups;
                if ($scope.group.parent_group_id != null) $scope.group.parent_group_id = parseInt($scope.group.parent_group_id);
                else $scope.group.parent_group_id = undefined;
                $scope.gridDesciendeDeOptions.loadData(false);
                if (!$scope.$$phase) $scope.$apply();

                // Si es un grupo interno no lo dejamos modificar
                if ($scope.group.blocked == true) $scope.allowWrite = false;
                $scope.prepareTitle();
            });
        }
        $scope.changePositionsVisibility = function (showPosition) {
            $scope.showPositions = showPosition;
            if (showPosition && (angular.isUndefined($scope.group_id) || $scope.group_id === "")) {
                $scope.showPositions = false;
            }
        };

        /* 
            Eliminado, ahora se hace una malla de grupos.
                * var options = {}
                options.group_id = $scope.group_id;
                Restangular.all('Groups').getList(options).then(function (results) {
                    $scope.selectParentGroup = treeService.groups(results, null);
                    var itemNull = {
                        id: null,
                        name: $filter('translate')('groups.no_desciende_de_nadie'),
                        color: "#cecece"
                    }
                    $scope.selectParentGroup.unshift(itemNull);
                    if (!$scope.$$phase) $scope.$apply();
            });
         */

        $scope.setColorParent = function (color) {
            $scope.group.color = color;
        };

        $scope.export = function () {
            var options = {
                recursiveElementId: $scope.group_id
            };
            datasetsService.exportByType("positions", options);
        };

        $scope.gridListPosition = {
            pdfTitle: $filter('translate')('persons.addresses'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            enablePaginationControls: false,
            paginationPageSize: 200,
            paginationPageSizes: [200],
            rowTemplate: '<div ng-dblclick="grid.appScope.addPositions(row.entity.id, row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                {
                    name: 'name', displayName: $filter('translate')('groups.name'), enableFiltering: true, enableHiding: false, enableColumnMenu: false, cellTemplate: "<div class=\"ui-grid-cell-contents\" >" + "{{row.entity.name}}" +
                        "<span> <i  ng-if='row.entity.FK_persons_positions_positions.length < 1' class='fas fa-user-alt-slash' title=\" " + $filter('translate')('positions.is_empty') + " \"></span>" + "</div>" },
                {
                    name: ' ', width: 250, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: "Histórico", action: 'ng-click="grid.appScope.personsPositionHistoric(row.entity.id, row.entity.name);" ng-if="row.entity.id"', cssIconClass: "fa fa-history" },
                        { title: "Editar", action: ' ng-click="grid.appScope.addPositions(row.entity.id, row.entity);"', cssIconClass: "fa fa-edit" },
                        { title: "Borrar", action: 'ng-click="grid.appScope.deletePositionDialog(row.entity.id,row.entity.name, row.entity);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                },
            ]
        };

        /* GRIDS */

        $scope.gridGroupContactInfo = {
            pdfTitle: $filter('translate')('persons.contact_data'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            enablePaginationControls: false,
            rowTemplate: '<div ng-dblclick="grid.appScope.addGroupContactDialog(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
                $timeout(function () {
                    gridApi.grid.sortColumn(gridApi.grid.columns[3], uiGridConstants.ASC);
                    // gridApi.grid.sortColumn(gridApi.grid.columns[1], uiGridConstants.ASC,true);
                    gridApi.grid.notifyDataChange(uiGridConstants.dataChange.ALL);
                });
            },
            columnDefs: [
                { name: 'id', visible: false, exporterSuppressExport: true },
                { name: 'FK_groups_contacts_groups_contacts_types.name', displayName: $filter('translate')('persons.contact_type') },
                { name: 'FK_groups_contacts_groups_contacts_types.order', displayName: $filter('translate')('persons.contact_type'), visible: false },
                { name: 'value', displayName: $filter('translate')('persons.value'), enableColumnMenu: false, enableFiltering: false, enableHiding: false },
                { name: 'notes', displayName: $filter('translate')('persons.notes'), enableColumnMenu: false, enableFiltering: false, visible: true },
                {
                    name: ' ', width: 100, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionIconTemplate([
                        { title: "", action: 'ng-click="grid.appScope.addGroupContactDialog(row.entity)"', cssIconClass: "fa fa-edit" },
                        { title: "", action: 'ng-click="grid.appScope.deleteGroupContactInfo(row.entity);" ng-if="grid.appScope.allowWrite" ', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                }
            ]
        };

        $scope.gridGroupAddresses = {
            pdfTitle: $filter('translate')('persons.addresses'),
            exporterMenuCsv: true,
            rowHeight: 45,
            enableGridMenu: true,
            enablePaginationControls: false,
            rowTemplate: '<div ng-dblclick="grid.appScope.addGroupAddressDialog(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, exporterSuppressExport: true },
                { name: 'FK_groups_addresses_groups_addresses_scopes.name', displayName: $filter('translate')('persons.contact_scope'), width: 150 },
                {
                    name: 'address_line_1', displayName: $filter('translate')('persons.address_line_1'),
                    cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.address_line_1}}<br/> {{row.entity.postal_code}}, {{row.entity.city}}</div>'

                },
                { name: 'notes', displayName: $filter('translate')('persons.notes') },
                /*{ name: 'address_line_2', displayName: $filter('translate')('persons.address_line_2'), enableColumnMenu: false, enableFiltering: false, visible: false },
                { name: 'postal_code', displayName: $filter('translate')('persons.postal_code'), enableColumnMenu: false, enableFiltering: false },
                { name: 'city', displayName: $filter('translate')('persons.city'), enableColumnMenu: false, enableFiltering: false },
                { name: 'state', displayName: $filter('translate')('persons.state'), enableColumnMenu: false, enableFiltering: false, enableHiding: false },
                { name: 'FK_groups_addresses_countries.name', displayName: $filter('translate')('persons.countries'), visible: false },*/
                {
                    name: ' ', width: 100, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionIconTemplate([
                        { title: "", action: 'ng-click="grid.appScope.addGroupAddressDialog(row.entity)"', cssIconClass: "fa fa-edit" },
                        { title: "", action: 'ng-click="grid.appScope.deleteGroupAddress(row.entity);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                }
            ]
        };
    };

    $scope.gridDesciendeDeOptions = {
        pdfTitle: $filter('translate')('groups.desciende_de'),
        exporterMenuCsv: true,
        enableGridMenu: true,
        showTreeExpandNoChildren: false,
        paginationPageSizes: [50, 200, 500],
        paginationPageSize: 50,
        onRegisterApi: function (gridApi) {
            this.gridApi = gridApi;
        },
        exporterFieldCallback: function (grid, row, col, value) {
            if (col.name === 'customName') {
                return row.entity.customNamePDF;
            } else {
                return value;
            }

        },
        columnDefs: [
            { name: 'id', visible: false, exporterSuppressExport: true },
            {
                name: 'customName', displayName: $filter('translate')('groups.name'), enableFiltering: false,
                enableHiding: false, cellTemplate: '<div ng-bind-html="row.entity[col.field] | to_trusted"></div>'

            },
            {
                name: 'is_parent', displayName: $filter('translate')('groups.is_parent'), enableFiltering: false, width: 100,
                enableHiding: false, enableColumnMenu: false, cellTemplate: "<div class=\"ui-grid-cell-contents\" style=\"padding-top: 3px;\">" +
                    "<input icheck type=\"checkbox\" ng-if=\"row.entity.is_parent\" ng-model=\"row.entity.is_parent\" ng-disabled=\"!grid.appScope.allowWrite\" ng-change=\"grid.appScope.check(row.entity)\"> " +
                    "<div ng-if=\"!row.entity.is_parent\" style=\"width: 20px; text-align: center;\">-</div></div> ",
            }
        ],
        getData: function (options) {
            var deferred = $q.defer();
            options.group_id = $stateParams.id;
            options.customName = $scope.search.name;
            options.parent_list = _.map($scope.group.FK_groups_groups_groups1, function (relation) { return relation.parent_group_id; });
            Restangular.all('GroupsGroups').getList(options).then(function (results) {
                var filledList = _.map(results, function (group) {
                    group.is_parent = _.filter($scope.group.FK_groups_groups_groups1, function (relation) {
                        return relation.parent_group_id == group.id;
                    }).length > 0;
                    return group;
                });

                var data = treeService.groups(filledList, null);
                data.totalRows = results.totalRows;
                deferred.resolve(data);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }
    };

    if ($state.is("groups.edit")) $scope.configure();
               
    /* GROUP */
    $scope.save = function (frmGroups) {

        if (angular.isDefined($scope.parent_group_id)) $scope.parent_group_id = $scope.parent_group_id.id;
        if ($scope.parent_group_id === 0) $scope.parent_group_id = null;
        if (angular.isUndefined($scope.group_id) || $scope.group_id === "") {
            if (angular.isUndefined($scope.group_id) || $scope.group_id === "") {
                $scope.group.FK_groups_groups_groups1 = _.map($scope.group.FK_groups_groups_groups1, function (group) { group.child_group_id = 0; group.id = 0; return group; });
            }

            Restangular.all('Groups').post($scope.group).then(function (result) {
                if (typeof (result.id) != "undefined") {
                    $scope.showPositions = true;
                    $scope.group = result;
                    $scope.group_id = result.id;
                    toastr.success($filter('translate')('groups.create_success'));
                    if (!angular.isUndefined($scope.comeFromPersons)) {
                        $scope.callbackClose('cancel', result);
                    } /*else {
                        $state.go("groups.list");
                    }*/
                }
            });
        } else {
            $scope.group.put().then(function (result) {
                if (typeof (result.id) != "undefined") {
                    toastr.success($filter('translate')('groups.edit_success'));
                    if (angular.isUndefined($scope.comeFromPersons)) {
                        $state.go("groups.list");
                    } else {
                        $scope.callbackClose('cancel', result);
                    }
                }
            });
        }

    };

    let normalizeAclUser = function (user) {
        const name = user.name || user.username || ('User #' + user.id);
        const username = user.username || '';
        const words = name.trim().split(/\s+/);
        const initials = (words.length >= 2 ? words[0][0] + words[words.length - 1][0] : name.slice(0, 2)).toUpperCase();
        return { id: user.id, label: name, initials: initials, sub: (username && username !== name) ? username : (user.email || '') };
    };

    let normalizeAclGroup = function (group) {
        const name = group.name || ('Group #' + group.id);
        return { id: group.id, label: name, initials: name.slice(0, 2).toUpperCase(), sub: group.members_count ? (group.members_count + ' miembros') : '' };
    };

    $scope.loadAclOptions = function () {
        if ($scope.aclOptionsLoaded) return $q.when();
        return $q.all([
            Restangular.all('Users').getList(),
            Restangular.all('UsersGroups').getList()
        ]).then(function (results) {
            $scope.aclUsers = (results[0] || []).map(normalizeAclUser);
            $scope.aclGroups = (results[1] || []).map(normalizeAclGroup);
            $scope.aclOptionsLoaded = true;
        });
    };

    $scope.openAclDialog = function () {
        $scope.loadAclOptions().then(function () {
            $scope.aclDialogState.visible = true;
        });
    };

    $scope.$watch('aclDialogState.savedVersion', function (newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
            $scope.group.put().then(function (result) {
                if (typeof result.id !== 'undefined') {
                    toastr.success($filter('translate')('groups.acl_save_success'));
                }
            });
        }
    });

     $scope.checkDelete = function () {

        let $modalInstance = $uibModal.open({
            animation: true,
            template: GroupsDeleteModalView,
            size: "md",
            controller: "GroupsDeleteModalCtrl",
            scope: $scope
        });

        /*
            modalService.confirm({
                title: $filter('translate')('groups.delete'),
                message: $filter('translate')('groups.delete_message')+" " + $scope.group.name + "?",
                onAccept: function () {
                    $scope.group.remove().then(function () {
                        toastr.success($filter('translate')('groups.delete_ok'));
                        $state.go("groups.list");
                    }, function (error) {
                        toastr.error(error.data.ExceptionMessage);
                    }
                    );
                }
            });
        */
    };
        
    /* POSITION */
    $scope.addPositions = function (id, position) {
        var editedIdx = 0;
        if ($scope.gridListPosition.data != null) editedIdx = $scope.gridListPosition.data.indexOf(position);
            
        if (angular.isUndefined(id)) id = "";
        if (angular.isUndefined(position)) {
            position = { isNew: true };
            position.group_id = $scope.group.id;
            position.position_type = $scope.group.group_type;
            position.FK_positions_tl_positions = [];
            position.FK_positions_contacts_positions = [];
            position.FK_positions_addresses_positions = [];
        }

        let $modalInstance = $uibModal.open({
            animation: true,
            template: PositionModalView,
            controller: "PositionModalCtrl",
            size: 'lg',
            resolve: {
                position: function () {
                    return position;
                }, position_list: function () {
                    return $scope.gridListPosition.data;
                }, group: function () {
                    return null;
                }, fromView: function () {
                    return $scope.fromView;
                }
            }

        });

        //Retorno de los datos desde el modal.
        $modalInstance.result.then(function (resultModal) {
            // Con esta línea forzamos el refresh cuando creas un cargo, de otro modo no aparece en la lista.
            $scope.configure();

            // SE duplican los cargos porque se guardan ya desde la ficha. Hacemos una recarga del grupo y se apaña
            
/*            var resultvalue = resultModal.edited;
               
            var position = {
                id: resultvalue.id,
                group_id: $scope.group.id,
                FK_positions_tl_positions: resultvalue.FK_positions_tl_positions,
                FK_positions_contacts_positions: resultvalue.FK_positions_contacts_positions,
                FK_positions_addresses_positions: resultvalue.FK_positions_addresses_positions,
                notes: resultvalue.notes,
                institution: resultvalue.institution,
                position_order: resultvalue.position_order,
                program_emails: resultvalue.program_emails,
                invitation_emails: resultvalue.invitation_emails
            };
            angular.forEach(resultvalue.FK_positions_tl_positions, function (item) {
                if (angular.isDefined($scope.group.language_id)) {
                    if (item.language_id == $scope.group.language_id) position.name = item.name;
                } else {
                    if (item.language_id == $rootScope.languageId) position.name = item.name;
                }
            });                
            if (resultvalue.isNew) {
                $scope.group.FK_positions_groups.push(position);
                $scope.gridListPosition.data = $scope.group.FK_positions_groups;
            } else {
                $scope.gridListPosition.data[editedIdx] = position;                    
            }

            if (!$scope.$$phase) $scope.$apply();*/

        }, function () {
            console.info('Modal dismissed at: ' + new Date());
            $scope.configure();
            //  $scope.identity = {};
        });

    };

    //Delete desde el listado
    $scope.deletePositionDialog = function (id, name, position) {
        modalService.confirm({
            title: $filter('translate')('positions.delete'),
            message: $filter('translate')('positions.delete_message') + " " + name + "?",
            onAccept: function () {
                if (typeof (id) != 'undefined') {
                    Restangular.one('Positions', id).remove().then(function () {
                        toastr.success($filter('translate')('positions.delete_ok'));
                        $scope.gridListPosition.data.splice($scope.gridListPosition.data.indexOf(position), 1);
                    });
                } else {
                    $scope.gridListPosition.data = $scope.gridListPosition.data.filter(function (el) { return el.id != $scope.id; });
                    var editedIdx = $scope.gridListPosition.data.indexOf(position);
                    $scope.group.FK_positions_groups.splice(editedIdx, 1);

                }
            }
        });

    };

    /* DESCIENDE DE */
    /* Función llamada al hacer click */
        $scope.check = function (group) {
            $scope.changesNotSaved = true;
        if (group.is_parent) {
            $scope.group.FK_groups_groups_groups1.push({
                parent_group_id: group.id,
                child_group_id: $stateParams.id
            });
        }
        else {
            $scope.group.FK_groups_groups_groups1 = _.filter($scope.group.FK_groups_groups_groups1, function (relation) { return relation.parent_group_id != group.id; });
            $scope.gridDesciendeDeOptions.loadData(false);
        }
    }

    $scope.modifyParents = function () {
        logService.debug("1");
        let $modalInstance = $uibModal.open({
            animation: true,
            template: GroupGroupModalView,
            controller: "GroupGroupModalCtrl",
            size: 'lg',
            resolve: {
                parent_list: function () {
                    return  $scope.group.FK_groups_groups_groups1;
                },
                allow_select_multple: function () {
                    return false;
                },
                show_color: function () {
                    return true;
                },
                group_type: function () {
                    return $scope.group.group_type != null ? $scope.group.group_type : "civil";
                }

            }

        });

        //Retorno de los datos desde el modal.
        $modalInstance.result.then(function (data) {
            var group_list = data.parents_clone;
            var apply_parent_color = data.apply_parent_color;
            $scope.changesNotSaved = true;
            if (apply_parent_color && group_list.length == 1) {
                $scope.group.color = group_list[0].color;                
            }
            $scope.group.FK_groups_groups_groups1 = group_list;
            
            $scope.gridDesciendeDeOptions.loadData(false);

            if (!$scope.$$phase) $scope.$apply();

        }, function () {
            console.info('Modal dismissed at: ' + new Date());
            //  $scope.identity = {};
        });

    };

    //Al añadir nuevo grupo descendiente de otro, añadimos ya el descendiente en el tab
    $scope.addDescendsFrom = function (data) {
        var group_list = data;
        var apply_parent_color = data.apply_parent_color;

        if (apply_parent_color && group_list.length == 1) {
            $scope.group.color = group_list[0].color;
        }
        $scope.group.FK_groups_groups_groups1 = group_list;

        if (!$scope.$$phase) $scope.$apply();
    }

    if ($stateParams.descendsFrom != null) {
        $scope.descendsFrom = $stateParams.descendsFrom;
        $scope.parents_clone = [{ parent_group_id: $scope.descendsFrom, color: "#cccccc" }];
        $scope.addDescendsFrom($scope.parents_clone);
    }

    /* HISTORIC */
    $scope.personsPositionHistoric = function (id, name) {
        let $modalInstance = $uibModal.open({
            animation: true,
            size: 'lg',
            template: HistoricModalView,
            controller: "HistoricModalCtrl",
            resolve: {
                position_id: function () {
                    return id;
                }, 
                name_position: function () {
                    return name;
                }
            } 
        });

        $modalInstance.result.then(function (data) {
            $scope.configure();
        }, function () {
            $scope.configure();
        });
    };

    $scope.deleteGroupContactInfo = function (groupContactInfo) {
        var editedIdx = $scope.gridGroupContactInfo.data.indexOf(groupContactInfo);
        $scope.group.FK_groups_contacts_groups.splice(editedIdx, 1);
    };

    $scope.deleteGroupAddress = function (entity) {
        var editedIdx = $scope.gridGroupAddresses.data.indexOf(entity);
        $scope.group.FK_groups_addresses_groups.splice(editedIdx, 1);
    };

    //Dialogos

    $scope.addGroupContactDialog = function (groupContactInfo) {
        var editedIdx = 0;
        if ($scope.gridGroupContactInfo.data !== null) editedIdx = $scope.gridGroupContactInfo.data.indexOf(groupContactInfo);

        if (angular.isUndefined(groupContactInfo)) groupContactInfo = { isNew: true };

        let $modalInstance = $uibModal.open({
            animation: true,
            template: GroupContactModalView,
            controller: "GroupContactModalCtrl",
            resolve: {
                groupContactInfo: function () {
                    return groupContactInfo;
                }
            }
        });
        //Response del modal
        $modalInstance.result.then(function (data) {

            var groupContactValue = data.edited;

            if (angular.isUndefined(groupContactValue.notes)) groupContactValue.notes = "";

            if (angular.isDefined(groupContactValue.value) && groupContactValue.value != "" && groupContactValue.value != null) {
                if (!angular.isUndefined(groupContactValue.FK_groups_contacts_groups_contacts_scopes) && groupContactValue.FK_groups_contacts_groups_contacts_scopes != null &&
                    !angular.isUndefined(groupContactValue.FK_groups_contacts_groups_contacts_types.selected) && groupContactValue.FK_groups_contacts_groups_contacts_types.selected != null) {

                    var groups_contacts = {
                        FK_groups_contacts_groups_contacts_scopes: angular.copy(groupContactValue.FK_groups_contacts_groups_contacts_scopes),
                        group_contact_scope_id: groupContactValue.FK_groups_contacts_groups_contacts_scopes.id,
                        FK_groups_contacts_groups_contacts_types: angular.copy(groupContactValue.FK_groups_contacts_groups_contacts_types.selected),
                        group_contact_type_id: groupContactValue.FK_groups_contacts_groups_contacts_types.selected.id,
                        group_id: $scope.group.id,
                        value: groupContactValue.value,
                        notes: groupContactValue.notes
                    };

                    if (groupContactValue.isNew) {
                        logService.debug($scope.group);
                        $scope.group.FK_groups_contacts_groups.push(groups_contacts);
                        $scope.gridGroupContactInfo.data = $scope.group.FK_groups_contacts_groups;
                    } else {
                        $scope.gridGroupContactInfo.data[editedIdx] = groups_contacts;
                    }

                    if (!$scope.$$phase) $scope.$apply();

                }

            }

        }, function () {

            console.info('Modal dismissed at: ' + new Date());
            if (!$scope.$$phase) $scope.$apply();

        });

    }; //addGroupsContactDialog

    $scope.addGroupAddressDialog = function (groupAddress) {

        var editedIdx = 0;

        if ($scope.gridGroupAddresses.data != null) editedIdx = $scope.gridGroupAddresses.data.indexOf(groupAddress);

        if (angular.isUndefined(groupAddress)) groupAddress = { isNew: true };

        let $modalInstance = $uibModal.open({
            animation: true,
            template: GroupAddressModalView,
            controller: "GroupAddressModalCtrl",
            resolve: {
                groupAddress: function () {
                    return groupAddress;
                }
            }
        });

        //Response del modal
        $modalInstance.result.then(function (data) {

            var groupAddressValue = data.edited;
            if (angular.isUndefined(groupAddressValue.state)) groupAddressValue.state = "";
            if (angular.isUndefined(groupAddressValue.postal_code)) groupAddressValue.postal_code = "";
            if (angular.isUndefined(groupAddressValue.address_line_2)) groupAddressValue.address_line_2 = "";
            if (angular.isUndefined(groupAddressValue.notes)) groupAddressValue.notes = "";

            if ((angular.isDefined(groupAddressValue.address_line_1) && groupAddressValue.address_line_1 != "" && groupAddressValue.address_line_1 != null) &&
                (angular.isDefined(groupAddressValue.city) && groupAddressValue.city != "" && groupAddressValue.city != null)) {
                if (!angular.isUndefined(groupAddressValue.FK_groups_addresses_groups_addresses_scopes) && groupAddressValue.FK_groups_addresses_groups_addresses_scopes != null &&
                    !angular.isUndefined(groupAddressValue.FK_groups_addresses_countries.selected) && groupAddressValue.FK_groups_addresses_countries.selected != null) {

                    var groups_contacts = {
                        FK_groups_addresses_groups_addresses_scopes: angular.copy(groupAddressValue.FK_groups_addresses_groups_addresses_scopes),
                        group_address_scope_id: groupAddressValue.FK_groups_addresses_groups_addresses_scopes.id,
                        FK_groups_addresses_countries: angular.copy(groupAddressValue.FK_groups_addresses_countries.selected),
                        country_id: groupAddressValue.FK_groups_addresses_countries.selected.id,
                        group_id: $scope.group.id,
                        address_line_1: groupAddressValue.address_line_1,
                        city: groupAddressValue.city,
                        state: groupAddressValue.state,
                        postal_code: groupAddressValue.postal_code,
                        address_line_2: groupAddressValue.address_line_2,
                        notes: groupAddressValue.notes
                    };
                    if (groupAddressValue.isNew) {
                        $scope.group.FK_groups_addresses_groups.push(groups_contacts);
                        $scope.gridGroupAddresses.data = $scope.group.FK_groups_addresses_groups;
                    } else {
                        $scope.gridGroupAddresses.data[editedIdx] = groups_contacts;
                    }

                    if (!$scope.$$phase) $scope.$apply();
                }
            }
        }, function () {

            console.info('Modal dismissed at: ' + new Date());
            if (!$scope.$$phase) $scope.$apply();

        });

    };

    // addGroupsAddressDialog

    $scope.openExtendPositions = function () {

        let $modalInstance = $uibModal.open({
            animation: true,
            template: ExtendPositionsModalView,
            controller: "ExtendPositionsModalCtrl",
            resolve: {
                group_id: function () {
                    return $scope.group_id;
                }
            },
            size: 'x-lg'
        });

        $modalInstance.result.then(function (result) {
            if (result) {
                toastr.success($filter('translate')('groups.positions_extended_success'));
                $scope.configure();
            } else {
                toastr.error($filter('translate')('groups.positions_extended_error'))
            }
        }, function () {

            console.info('Modal dismissed at: ' + new Date());

        });
    };

    $scope.openAttendedEvents = function () {

        let $modalInstance = $uibModal.open({
            animation: true,
            template: AttendedEventsModalView,
            controller: "AttendedEventsPositionsModalCtrl",
            resolve: {
                position_id: function () {
                    return null;
                },
                group_id: function () {
                    return $scope.group_id;
                }
            },
            size: 'x-lg'
        });

        $modalInstance.result.then(function () {

        }, function () {

            console.info('Modal dismissed at: ' + new Date());

        });
    };

    $scope.applyColorToSubgroups = function () {
        modalService.confirm({
            title: $filter('translate')('groups.warning'),
            message: $filter('translate')('groups.color_subgroups_question'),
            onAccept: function () {
                Restangular.all('Groups').customGET("ApplyColorToSubgroups", { group_id: $scope.group.id, color: $scope.group.color }).then(function (result) {
                    if (result) {
                        toastr.success($filter('translate')('groups.color_applied_correctly'));
                    } else {
                        toastr.error($filter('translate')('groups.color_applied_error'))
                    }
                });                
                /*$scope.budget_group.remove().then(function () {
                    toastr.success($filter('translate')('budget_groups.remove_success'));
                    $state.go("budget_groups.list");
                });*/
            }
        });

    }

}])
    .controller("PositionModalCtrl", ['$q', 'LoginService', '$scope', '$uibModalInstance', 'Restangular', 'position', 'position_list', 'group', 'modalService', '$filter', 'gridService', '$uibModal', 'uiGridConstants', '$timeout', 'fromView', '$rootScope', 'logService',
        function ($q, LoginService, $scope, $uibModalInstance, Restangular, position, position_list, group, modalService, $filter, gridService, $uibModal, uiGridConstants, $timeout, fromView, $rootScope, logService) {
   
    //Comprobamos si tiene permiso escritura
    $scope.allowWrite = LoginService.permissionExist("GROUPS_WRITE");

    $scope.position = (!angular.isUndefined(position) ? angular.copy(position) : {});
        //$scope.search = {};
        // if (!angular.isUndefined(position))
          //  $scope.search.institution = $scope.position.institution; 

    $scope.reloadPositionsEmails = function () {
        Restangular.all('PositionsMails').getList({ position_id: position.id }).then(function (results) {
            $scope.positionsMails = results;
        });

    }

    $scope.reloadPositionsEmails();

    $scope.loadPersonsTreatments = function (reload) {
        return Restangular.all('PersonsTreatments').getList().then(function (treatments) {
            $scope.positionTreatments = treatments;
            const positionDefault = $scope.positionTreatments.filter(pt => { return pt.position_default });
            if ($scope.position.position_treatment_id == null || $scope.position.position_treatment_id == 0) {
                $scope.position.position_treatment_id = positionDefault[0].id;
            }
            
        });
    };

    $scope.loadPersonsTreatments(false);

    var position_list = position_list != null ? position_list : [];

    $scope.positionOrigin = (!angular.isUndefined(position) ? position : {});

    logService.debug($scope.position);

        // Búsqueda de instituciones

        $scope.getInstitutionsSearch = function (val) {

            if (val == null) {
                val = '';
            } else {
                val = val.replace(/[:.?*+^$[\\(){|]/, "");
            }

            let ret = [];

            ret = Restangular.all('search/institutions/' + val).getList().then(function (searchTerms) {
                return searchTerms;
            });

            return ret;

        };

        $scope.clearInstitution = function () {

            if ($scope.position.institution_id != null)
                $scope.position.institution_id = null;

        };

        $scope.institutionSelected = function ($item) {

            $item.id != 0 ? $scope.position.institution_id = $item.id : $scope.position.institution_id = null;
            $scope.position.institution = $scope.position.institution.term;
            logService.debug($scope.position);

        };

    // Fin 

    // Edición de instituciones 
        $scope.editInstitution = function (id) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: InstitutionEditModalView,
                size: "lg",
                controller: "institutionsEditCtrl",
                scope: $scope,
                resolve: {
                    id_from_modal: function () {
                        return id;
                    }
                }          
            });
        };

    // Importación desde instituciones

        /*
        $scope.importFromInstitution = function () {
            Restangular.one('Institutions', $scope.position.institution_id).get().then(function (result) {
                $modalInstance = $uibModal.open({
                    animation: true,
                    template: 'app/institutions/InstitutionPreviewModal.html',
                    controller: "InstitutionPreviewModalCtrl",
                    resolve: {
                        institutionMails: function () {
                            return result.mails;
                        },
                        institutionAddresses: function () {
                            return result.addresses;
                        },
                        institutionContacts: function () {
                            return result.contacts;
                        },
                    },
                    scope: $scope,
                    size: 'lg'
                });
            });
        };
        */

    // Comprobamos si la empresa tiene marcado la opción de el artículo 10 para mostrar las opciones en consecuencia

    $scope.article10 = false;

    Restangular.one('Companies', $rootScope.company_id).get().then(function (results) {
        if (results.article_10 == true) { $scope.article10 = true; }
        if (results.article_12 == true) { $scope.article12 = true; }


    }),

    //Delete desde el popup
    $scope.checkDeletePosition = function () {
        modalService.confirm({
            title: $filter('translate')('positions.delete'),
            message: $filter('translate')('positions.delete_message')+" "+ $scope.position.name + "?",
            onAccept: function () {
                Restangular.one('Positions', $scope.position.id).remove().then(function () {
                    toastr.success($filter('translate')('positions.delete_ok'));
                    $uibModalInstance.close({ deleted: $scope.position, origin: $scope.positionOrigin});
                });
            }
        });
    };

    // Ver histórico
    $scope.viewHistoric = function () {
        let $modalInstance = $uibModal.open({
            animation: true,
            size: 'lg',
            template: HistoricModalView,
            controller: "HistoricModalCtrl",
            resolve: {
                position_id: function () {
                    return $scope.position.id;
                },
                name_position: function () {
                    return $scope.position.name;
                }
            }
        });  
    };
    
    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
        };


    $scope.checkSavePosition = function () {

        if ($scope.position.shared_by > 1) {

            modalService.confirm({
                title: $filter('translate')('groups.position_shared_by_title'),
                message: $filter('translate')('groups.position_shared_by_message') + ". " + `(${$scope.position.shared_by})` + " " + $filter('translate')('groups.position_shared_by_confirmation_warning'),
                onAccept: function () {
                    $scope.savePosition();
                },
            }, 'md');

        } else {

            $scope.savePosition();

        }
   }

        $scope.savePosition = function () {

        logService.debug("savePosition", $scope.position);

        var exists = false;
        if ($scope.position.isNew) {
            exists = _.some(position_list, function (position) {
                return _.some(position.FK_positions_tl_positions, function (tl) {
                    return _.some($scope.position.FK_positions_tl_positions, function (scope_tl) {
                        return angular.isDefined(scope_tl.name) && scope_tl.name != "" && angular.isDefined(tl.name) && tl.name != ""
                            && tl.name == scope_tl.name && tl.language_id == scope_tl.language_id;
                    });
                });
            });
        }
            if (exists) {

            modalService.confirm({
                title: $filter('translate')('positions.delete'),
                message: $filter('translate')('groups.repeated_position'),
                onAccept: function () {
                    $uibModalInstance.close({ edited: $scope.position, origin: $scope.positionOrigin });
                }
            });

        } else {

            if (fromView == 'Persons' || angular.isUndefined(fromView)) {
                if ($scope.positionsMails.length > 0) {
                    $scope.position.FK_positions_mails_positions = $scope.positionsMails;
                }
                Restangular.all('Positions').post($scope.position).then(function (result) {
                    // Devolvemos el control al principal
                    $uibModalInstance.close({ edited: $scope.position, origin: $scope.positionOrigin });
                });
            } else {
                if ($scope.positionsMails.length > 0) {
                    $scope.position.FK_positions_mails_positions = $scope.positionsMails;
                }

                $uibModalInstance.close({ edited: $scope.position, origin: $scope.positionOrigin });
            }
            
        }

        };

   // savePosition

    $timeout(function () {
        $scope.gridPositionAddresses.data = $scope.position.FK_positions_addresses_positions;
        $scope.gridPositionContactInfo.data = $scope.position.FK_positions_contacts_positions;
        /*$scope.gridPositionContactInfo.gridApi.grid.notifyDataChange(uiGridConstants.dataChange.ALL);*/
    });

    /* GRIDS */
    $scope.gridPositionContactInfo = {
        pdfTitle: $filter('translate')('persons.contact_data'),
        exporterMenuCsv: true,
        enableGridMenu: false,
        enablePaginationControls: false,
        enableFiltering: false,
        minRowsToShow:4,
      /*  paginationPageSizes: [1],
        paginationPageSize: 1,*/
        rowTemplate: '<div ng-dblclick="grid.appScope.addPositionsContactDialog(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
        onRegisterApi: function (gridApi) {
            this.gridApi = gridApi;
            $timeout(function () {
                gridApi.grid.sortColumn(gridApi.grid.columns[3], uiGridConstants.ASC);
                // gridApi.grid.sortColumn(gridApi.grid.columns[1], uiGridConstants.ASC,true);
                gridApi.grid.notifyDataChange(uiGridConstants.dataChange.ALL);
            });
        },
        columnDefs: [
            { name: 'id', visible: false, enableColumnMenu: false, enableHiding: false, exporterSuppressExport: true },
            { name: 'FK_positions_contacts_positions_contacts_types.name', displayName: $filter('translate')('persons.contact_type'), enableHiding: false, enableColumnMenu: false },
            { name: 'FK_positions_contacts_positions_contacts_types.order', displayName: '', enableColumnMenu: false, enableHiding: false, visible: false },
            { name: 'value', displayName: $filter('translate')('persons.value'), enableColumnMenu: false, enableFiltering: false, enableHiding: false },
            { name: 'notes', displayName: $filter('translate')('persons.notes'), enableColumnMenu: false, enableFiltering: false, enableHiding: false, visible: false },
            {
                name: ' ', width: 100, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionIconTemplate([
                    { title: "", action: 'ng-click="grid.appScope.addPositionsContactDialog(row.entity)"', cssIconClass: "fa fa-edit" },
                    { title: "", action: 'ng-click="grid.appScope.deletePositionContactInfo(row.entity);" ng-if="grid.appScope.allowWrite" ', cssIconClass: "fa fa-remove" }
                ], { cssClass: "pull-right" })
            }
        ]
    }

    $scope.gridPositionAddresses = {
        pdfTitle: $filter('translate')('persons.addresses'),
        exporterMenuCsv: true,
        enableGridMenu: true,
        enablePaginationControls: false,
        rowHeight: 45,
        minRowsToShow: 3,
        rowTemplate: '<div ng-dblclick="grid.appScope.addPositionsAddressDialog(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
        onRegisterApi: function (gridApi) {
            this.gridApi = gridApi;
        },
        columnDefs: [
            { name: 'id', visible: false, exporterSuppressExport: true },
            { name: 'address_line_1', displayName: $filter('translate')('persons.address_line_1'), enableColumnMenu: false, enableFiltering: false, enableHiding: false,
                cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.address_line_1}}<br/> {{row.entity.postal_code}}, {{row.entity.city}}</div>',
            },
            { name: 'state', displayName: $filter('translate')('persons.contact_state'), width: 150 },
            { name: 'city', displayName: $filter('translate')('persons.contact_city'), width: 150 },
            /*{ name: 'address_line_2', displayName: $filter('translate')('persons.address_line_2'), enableColumnMenu: false, enableFiltering: false, visible: false },
            { name: 'postal_code', displayName: $filter('translate')('persons.postal_code'), enableColumnMenu: false, enableFiltering: false },
            { name: 'city', displayName: $filter('translate')('persons.city'), enableColumnMenu: false, enableFiltering: false },
            { name: 'state', displayName: $filter('translate')('persons.state'), enableColumnMenu: false, enableFiltering: false, enableHiding: false },*/
            { name: 'notes', displayName: $filter('translate')('persons.notes'), visible: true },
            {
                name: ' ', width: 100, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionIconTemplate([
                    { title: "", action: 'ng-click="grid.appScope.addPositionsAddressDialog(row.entity)"', cssIconClass: "fa fa-edit" },
                    { title: "", action: 'ng-click="$event.stopPropagation();grid.appScope.deletePositionAddress(row.entity);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                ], { cssClass: "pull-right" })
            }
        ]
    }       

        $scope.addEmailsPositions = function (position) {

            let $modalInstance = $uibModal.open({
                animation: true,
                template: PositionMailModalView,
                controller: "PositionMailModalCtrl",
                resolve: {
                    position: function () {
                        return position;
                    },
                    position_email: function () {
                        return {use_for_invitation: true, use_for_program: true, use_for_others: true};
                    }

                }
            });
            //Response del modal
            $modalInstance.result.then(function (data) {
                if (!angular.isUndefined(data)) {
                    $scope.positionsMails.push(data.edited);
                } else {
                    $scope.reloadPositionsEmails();
                }
            });

        };

        $scope.editPostionMail = function (mail) {

            let $modalInstance = $uibModal.open({
                animation: true,
                template: PositionMailModalView,
                controller: "PositionMailModalCtrl",
                resolve: {
                    position: function () {
                        return position;
                    },
                    position_email: function () {
                        return mail;
                    }
                }
            });

            //Response del modal
            $modalInstance.result.then(function (data) {
                $scope.reloadPositionsEmails();
            });
        };


    $scope.addPositionsAddressDialog = function (positionAddress) {
        var editedIdx = 0;
        if ($scope.gridPositionAddresses.data != null) editedIdx = $scope.gridPositionAddresses.data.indexOf(positionAddress);
        if (angular.isUndefined(positionAddress)) positionAddress = { isNew: true };

        let $modalInstance = $uibModal.open({
            animation: true,
            template: PositionAddressModalView,
            controller: "PositionAddressModalCtrl",
            resolve: {
                positionAddress: function () {
                    return positionAddress;
                }
            }
        });
        //Response del modal
        $modalInstance.result.then(function (data) {
            $scope.changesNotSaved = true;
            var positionAddressValue = data.edited;
            console.log(positionAddressValue);
            if (angular.isUndefined(positionAddressValue.state)) positionAddressValue.state = "";
            if (angular.isUndefined(positionAddressValue.postal_code)) positionAddressValue.postal_code = "";
            if (angular.isUndefined(positionAddressValue.address_line_2)) positionAddressValue.address_line_2 = "";
            if (angular.isUndefined(positionAddressValue.notes)) positionAddressValue.notes = "";

            if ((angular.isDefined(positionAddressValue.address_line_1) && positionAddressValue.address_line_1 != "" && positionAddressValue.address_line_1 != null) &&
                (angular.isDefined(positionAddressValue.city) && positionAddressValue.city != "" && positionAddressValue.city != null)) {
                if (!angular.isUndefined(positionAddressValue.FK_positions_addresses_positions_addresses_scopes) && positionAddressValue.FK_positions_addresses_positions_addresses_scopes !== null &&
                    !angular.isUndefined(positionAddressValue.FK_positions_addresses_countries.selected) && positionAddressValue.FK_positions_addresses_countries.selected !== null) {

                    var positions_contacts = {
                        FK_positions_addresses_positions_addresses_scopes: angular.copy(positionAddressValue.FK_positions_addresses_positions_addresses_scopes),
                        position_address_scope_id: positionAddressValue.FK_positions_addresses_positions_addresses_scopes.id,
                        FK_positions_addresses_countries: angular.copy(positionAddressValue.FK_positions_addresses_countries.selected),
                        country_id: positionAddressValue.FK_positions_addresses_countries.selected.id,
                        position_id: $scope.position.id,
                        address_line_1: positionAddressValue.address_line_1,
                        city: positionAddressValue.city,
                        state: positionAddressValue.state,
                        postal_code: positionAddressValue.postal_code,
                        address_line_2: positionAddressValue.address_line_2,
                        notes: positionAddressValue.notes
                    };
                    if (positionAddressValue.isNew) {
                        $scope.position.FK_positions_addresses_positions.push(positions_contacts);
                        $scope.gridPositionAddresses.data = $scope.position.FK_positions_addresses_positions;
                    } else {
                        $scope.gridPositionAddresses.data[editedIdx] = positions_contacts;
                    }

                    if (!$scope.$$phase) $scope.$apply();
                }

            }

        }, function () {
            console.info('Modal dismissed at: ' + new Date());
            if (!$scope.$$phase) $scope.$apply();
        });

    };

    $scope.addPositionsContactDialog = function (positionContactInfo) {
        var editedIdx = 0;

        if ($scope.gridPositionContactInfo.data != null) editedIdx = $scope.gridPositionContactInfo.data.indexOf(positionContactInfo);

        if (angular.isUndefined(positionContactInfo)) positionContactInfo = { isNew: true };

        let $modalInstance = $uibModal.open({
            animation: true,
            template: PositionContactModalView,
            controller: "PositionContactModalCtrl",
            resolve: {
                positionContactInfo: function () {
                    return positionContactInfo;
                }
            }
        });
        //Response del modal
        $modalInstance.result.then(function (data) {

            var positionContactValue = data.edited;
            $scope.changesNotSaved = true;
            if (angular.isUndefined(positionContactValue.notes)) positionContactValue.notes = "";

            if (angular.isDefined(positionContactValue.value) && positionContactValue.value !== "" && positionContactValue.value !== null) {
                if (!angular.isUndefined(positionContactValue.FK_positions_contacts_positions_contacts_scopes) && positionContactValue.FK_positions_contacts_positions_contacts_scopes !== null &&
                    !angular.isUndefined(positionContactValue.FK_positions_contacts_positions_contacts_types.selected) && positionContactValue.FK_positions_contacts_positions_contacts_types.selected !== null) {
                    var positions_contacts = {
                        FK_positions_contacts_positions_contacts_scopes: angular.copy(positionContactValue.FK_positions_contacts_positions_contacts_scopes),
                        position_contact_scope_id: positionContactValue.FK_positions_contacts_positions_contacts_scopes.id,
                        FK_positions_contacts_positions_contacts_types: angular.copy(positionContactValue.FK_positions_contacts_positions_contacts_types.selected),
                        position_contact_type_id: positionContactValue.FK_positions_contacts_positions_contacts_types.selected.id,
                        position_id: $scope.position.id,
                        value: positionContactValue.value,
                        notes: positionContactValue.notes
                    };

                    if (positionContactValue.isNew) {
                        $scope.position.FK_positions_contacts_positions.push(positions_contacts);
                        $scope.gridPositionContactInfo.data = $scope.position.FK_positions_contacts_positions;
                    } else {
                        $scope.gridPositionContactInfo.data[editedIdx] = positions_contacts;
                    }

                    if (!$scope.$$phase) $scope.$apply();

                }

            }

        }, function () {
            console.info('Modal dismissed at: ' + new Date());
            if (!$scope.$$phase) $scope.$apply();
        });

    };

    $scope.deletePositionContactInfo = function (positionContactInfo) {
        var editedIdx = $scope.gridPositionContactInfo.data.indexOf(positionContactInfo);
        $scope.position.FK_positions_contacts_positions.splice(editedIdx, 1);
        $scope.changesNotSaved = true;
    }

    $scope.deletePositionAddress = function (entity) {
        var editedIdx = $scope.gridPositionAddresses.data.indexOf(entity);
        $scope.position.FK_positions_addresses_positions.splice(editedIdx, 1);
        $scope.changesNotSaved = true;
    }

    $scope.openAttendedEvents = function () {
        let $modalInstance = $uibModal.open({
            animation: true,
            template: AttendedEventsModalView,
            controller: "AttendedEventsPositionsModalCtrl",
            resolve: {
                position_id: function () {
                    return $scope.position.id;
                },
                group_id: function () {
                    return null;
                }
            },
            size: 'x-lg'
        });

        $modalInstance.result.then(function () {

        }, function () {
            console.info('Modal dismissed at: ' + new Date());
        });
    }

    $scope.duplicatePosition = function () {        
        let $modalInstance = $uibModal.open({
            animation: true,
            template: GroupGroupModalView,
            controller: "GroupGroupModalCtrl",
            size: 'lg',
            resolve: {
                parent_list: function () {
                    return [];
                },
                allow_select_multple: function () {
                    return true;
                },
                show_color: function () {
                    return false;
                },
                group_type: function () {
                    return $scope.position.position_type != null ? $scope.position.position_type : "civil";
                }
            }

        });

        $modalInstance.result.then(function (data) {

            let group_list = data.parents_clone;

            var groupsIds = [];

            angular.forEach(group_list, function (item) {
                groupsIds.push(item.parent_group_id);
            });

            Restangular.all('Positions').customGET("DuplicatePositionInGroups", { position_id: $scope.position.id, groupsIds: groupsIds }).then(function (result) {
                if (result) {
                    toastr.success($filter('translate')('position.duplicate_success'));
                } else {
                    toastr.error($filter('translate')('position.duplicate_error'))
                }
            });

        }, function () {
            console.info('Modal dismissed at: ' + new Date());
            //  $scope.identity = {};
        });
    }

    $('#ibox_contact .ibox-content').slideUp();
    $('#ibox_addresses .ibox-content').slideUp();
    //$('#ibox_contact .ibox-tools a.collapse-link i').toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    //$('#ibox_addresses .ibox-tools a.collapse-link i').toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
}])

.controller("HistoricModalCtrl", ['$uibModal', 'LoginService', '$scope', '$uibModalInstance', 'Restangular', 'position_id', 'name_position', 'modalService', '$filter', 'gridService', '$timeout', 'logService',
    function ($uibModal, LoginService, $scope, $uibModalInstance, Restangular, position_id, name_position, modalService, $filter, gridService, $timeout, logService) {
   
    $scope.allowReadPersons = LoginService.permissionExist("PERSONS_READ");
    $scope.personPosition = {};
    $scope.name_position = name_position;

    $scope.only_authorities = false; 

    $scope.parsePersonType = function (person_type) {
        //logService.debug(person_type);
        let result = "";

        if (person_type == "authority") {

            result = $filter('translate')('persons.title');

        } if (person_type === "anonymous") {

            result = $filter('translate')('persons.title_anonymous');

        } else if (person_type === "imported") {

            result = $filter('translate')('persons.title_imported');

        } else if (person_type === "enrolled") {

            result = $filter('translate')('inscriptions_forms.inscripted');

        }

        return result;
    };

    $scope.gridPersonsHistoric = {
        pdfTitle: $filter('translate')('persons_positions.historic_title'),
        exporterMenuCsv: true,
        enableGridMenu: true,
        gridMenuShowHideColumns: false,
        paginationPageSizes: [10, 20, 30],
        paginationPageSize: 10,
        enableHiding: false,
        onRegisterApi: function (gridApi) {
            this.gridApi = gridApi;
            this.gridApi.core.on.rowsRendered($scope, callbackFunctionItemChange);
            this.gridApi.selection.on.rowSelectionChanged($scope, callbackFunctionRowSelected);
            this.gridApi.selection.on.rowSelectionChangedBatch($scope, callbackFunctionRowSelected);
        },
        columnDefs: [
            { name: 'id', visible: false, exporterSuppressExport: true, enableFiltering: false },
            {
                field: 'FK_persons_positions_persons.FK_persons_images.image_small',
                customFormatFn: function (value) {
                    if (value != null && typeof (value) !== "undefined") {
                        var img = {
                            image: value,
                            width: 30
                        };
                        return img;
                    } else {
                        return "";
                    }
                },
                displayName: '', cellTemplate: "<img width=\"30px\" ng-show=\"grid.getCellValue(row, col)\" ng-src=\"{{grid.getCellValue(row, col)}}\" style=\"margin-left:0px;margin-top:0px;\" lazy-src>", width: 50,
                enableFiltering: false, enableSorting: false
            },
            { name: 'name', field: 'FK_persons_positions_persons.name', displayName: $filter('translate')('persons.name'), enableFiltering: true },
            { name: 'surname', field: 'FK_persons_positions_persons.surname', displayName: $filter('translate')('persons.surname'), enableFiltering: true },
            { name: 'lastname', field: 'FK_persons_positions_persons.lastname', displayName: $filter('translate')('persons.lastname'), enableFiltering: true },
            {
                name: 'person_type', field: 'FK_persons_positions_persons.person_type', displayName: $filter('translate')('persons.type'), enableFiltering: true,
                cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{grid.appScope.parsePersonType(row.entity.FK_persons_positions_persons.person_type)}}</div>'
            }
            ,
            {
                name: 'from_date', displayName: $filter('translate')('persons_positions.from_date'), type: 'date', cellFilter: 'date:\'dd/MM/yyyy\'',
                filterHeaderTemplate: '<div class="ui-grid-filter-container">' +
                    '<input ui-date="{ dateFormat: \'dd/mm/yy\', firstDay: 1, maxDate: grid.appScope.personPosition.fromDate }" ng-change="grid.appScope.gridPersonsHistoric.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="from_date" ng-model="grid.appScope.personPosition.fromDate" required>' +
                    '</div>'
            },
            {
                name: 'to_date', displayName: $filter('translate')('persons_positions.to_date'), type: 'date', cellFilter: 'date:\'dd/MM/yyyy\'',
                filterHeaderTemplate: '<div class="ui-grid-filter-container">' +
                    '<input ui-date="{ dateFormat: \'dd/mm/yy\', firstDay: 1, maxDate: grid.appScope.personPosition.toDate }" ng-change="grid.appScope.gridPersonsHistoric.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="to_date" ng-model="grid.appScope.personPosition.toDate" required>' +
                    '</div>'
            },
            {
                name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                    { title: $filter('translate')('persons_positions.see_file'), action: 'target="_blank" ng-if="!row.entity.is_deleted" ui-sref="persons.edit({person_type:row.entity.FK_persons_positions_persons.person_type ,id:row.entity.FK_persons_positions_persons.id})" ng-click="grid.appScope.onCancel();" ng-if="grid.appScope.allowReadPersons" ', cssIconClass: "fa fa-file" },
                ], { cssClass: "pull-right" })
            },
        ],
        getData: function (options) {
            $scope.selectedRows = [];
            if (!!$scope.personPosition.fromDate) options.from_date = $scope.personPosition.fromDate;
            if (!!$scope.personPosition.toDate) options.to_date = $scope.personPosition.toDate;
            options.position_id = position_id;

            if ($scope.only_authorities == true) {
                   options.person_type = "authority"; //Solo se muestran los que son de tipo autoridad.
            }

            return Restangular.all('PersonsPositions').getList(options); //TODO: traer las imágenes ahora, no en la misma peticion. (hacerlo como en persons-list.js)
        }
    };

    let callbackFunctionRowSelected = function (row, evt) {
        let addAll = row.length > 1;
        if (!addAll) {
            //buscamos si ya existe la persona añadida
            var index = $scope.selectedRows.map(function (e) { return e.id; }).indexOf(row.entity.id);
            if (index < 0) {
                if (row.isSelected) {
                    $scope.selectedRows.push({ id: row.entity.id, positionId: [row.entity.positionId] });
                } else {
                    $scope.selectedRows.splice(index, 1);
                }
            } else {
                //ya existe, si is seleccionado, lo añadimos y sino lo borramos.
                if (row.isSelected) {
                    $scope.selectedRows.map(function (e) { if (e.id == row.entity.id) e.positionId.push(row.entity.positionId) });
                } else {
                    for (let i = 0; i < $scope.selectedRows.length; i++) {
                        if ($scope.selectedRows[i].id == row.entity.id) {

                            //var indexPosition = $scope.selectedRows[i].positionId.map(function (e) { return e.positionId; }).indexOf(row.entity.positionId);
                            var indexPosition = $scope.selectedRows[i].positionId.indexOf(row.entity.positionId);
                            var lengthOfPositions = $scope.selectedRows[i].positionId.map(function (e) { return e.positionId; }).length;
                            logService.debug(row.entity.positionId + " " + indexPosition);
                        }
                    }
                    $scope.selectedRows.map(function (e) { if (e.id == row.entity.id) e.positionId.splice(indexPosition, 1) });
                    if (lengthOfPositions == 1) {
                        //eliminamos a la persona
                        var index = $scope.selectedRows.map(function (e) { return e.id; }).indexOf(row.entity.id);
                        $scope.selectedRows.splice(index, 1);
                    }
                }
            }
        } else {
            if (row[0].isSelected) {
                //se ha seleccionado todo.
                $scope.selectedRows = [];
                for (let i = 0; i < $scope.gridPersonsHistoric.gridApi.grid.options.totalItems; i++) { $scope.selectedRows.push(i); };
            } else {
                $scope.selectedRows = [];
            }
        }
    }

    let callbackFunctionItemChange = function () {
        $timeout(function () {
            for (var i = 0; i < $scope.gridPersonsHistoric.data.length; i++) {
                var row = $scope.gridPersonsHistoric.data[i];
                for (var select = 0; select < $scope.selectedRows.length; select++) {
                    let selected = $scope.selectedRows[select];
                    if (row.id == selected.id) {
                        $scope.gridPersonsHistoric.gridApi.selection.toggleRowSelection(row);
                        break
                    }
                };
            }
        }, 350);//lo pongo así porque sino falla la primera vez
    }

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.selectedPersonsToEndPosition = function () {
        var addAll = $scope.gridPersonsHistoric.gridApi.selection.getSelectAllState();
        if (addAll) {
            let options: any = {};
            if (!!$scope.personPosition.fromDate) options.from_date = $scope.personPosition.fromDate;
            if (!!$scope.personPosition.toDate) options.to_date = $scope.personPosition.toDate;
            options.position_id = position_id;
            options.person_type = "authority"; //Solo se muestran los que son de tipo autoridad.
            Restangular.all('PersonsPositions').getList(options).then(function (results) {
                var ids = [];
                angular.forEach(results, function (row) {
                    ids.push(row.id);
                });
                if (ids.length > 0) {
                    logService.debug(ids);
                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: EndPositionAndAddNewPositionView,
                        controller: "EndPositionAndAddNewPositionModalCtrl",
                        size: 'md',
                        resolve: {
                            endPosition: true
                        }
                    });

                    $modalInstance.result.then(function (info) {
                        info.position_prev_id = position_id;
                        info.listPersonsIds = ids;
                        Restangular.all('PersonsPositions').customPOST(info, "EndPositions", {}).then(function (result) {
                            toastr.success($filter('translate')('persons_positions.end_position_success'));
                            $scope.gridPersonsHistoric.loadData(false);
                        });
                    }, function () {
                        console.info('Modal dismissed at: ' + new Date());
                    });
                } else {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('persons_positions.select_persons'),
                        onAccept: function () { }
                    });
                }
            });

        } else {
            var rows = $scope.gridPersonsHistoric.gridApi.selection.getSelectedRows();
            var ids = [];
            angular.forEach(rows, function (row) {
                ids.push(row.id);
            });
            if (ids.length > 0) {
                logService.debug(ids);
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: EndPositionAndAddNewPositionView,
                    controller: "EndPositionAndAddNewPositionModalCtrl",
                    size: 'md',
                    resolve: {
                        endPosition: true
                    }
                });
                $modalInstance.result.then(function (info) {
                    info.position_prev_id = position_id;
                    info.listPersonsIds = ids;
                    Restangular.all('PersonsPositions').customPOST(info, "EndPositions", {}).then(function (result) {
                        toastr.success($filter('translate')('persons_positions.end_position_success'));
                        $scope.gridPersonsHistoric.loadData(false);
                    });
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                });
            } else {
                modalService.message({
                    title: "Error",
                    message: $filter('translate')('persons_positions.select_persons'),
                    onAccept: function () { }
                });
            }
        }
        
    };

    $scope.addPersonsToPosition = function () {
        let $modalInstance = $uibModal.open({
            animation: true,
            template: SearchPersonsModalView,
            size: "lg",
            controller: "SearchPersonsModalCtrl",
            scope: $scope,
            resolve: {
                options: function () {
                    return {};
                }
            }
        });
        //Response del modal
        $modalInstance.result.then(function (data) {
            if (data.length > 0) {
                let $modalInstance2 = $uibModal.open({
                    animation: true,
                    template: EndPositionAndAddNewPositionView,
                    controller: "EndPositionAndAddNewPositionModalCtrl",
                    size: 'md',
                    resolve: {
                        endPosition: false
                    }
                });
                $modalInstance2.result.then(function (info) {
                    logService.debug(info);
                    info.position_prev_id = position_id;
                    info.listPersonsIds = data;
                    Restangular.all('PersonsPositions').customPOST(info, "AddPositions", {}).then(function (result) {
                        toastr.success($filter('translate')('persons_positions.end_position_success'));
                        $scope.gridPersonsHistoric.loadData(false);
                    });
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                });
            }
            if (!$scope.$$phase) $scope.$apply();
        }, function () {
            console.info('Modal dismissed at: ' + new Date());
            if (!$scope.$$phase) $scope.$apply();
        });
    };

}])

.controller("GroupContactModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'groupContactInfo', function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, groupContactInfo) {

    $scope.allowWrite = LoginService.permissionExist("GROUPS_WRITE");
    $scope.groupContactModal = (!angular.isUndefined(groupContactInfo) ? angular.copy(groupContactInfo) : {});
    $scope.groupContactOrigin = (!angular.isUndefined(groupContactInfo) ? groupContactInfo : {});

    //Groups_contacts_scopes y tl
    Restangular.all('GroupsContactsScopes').getList().then(function (groupsContactsScopes) {

        $scope.groupsContactsScopes = groupsContactsScopes
        //Seleccionamos el correspondiente.
        if ($scope.groupContactModal != null && angular.isUndefined($scope.groupContactModal.group_contact_scope_id)) {
            $scope.groupsContactsScopes.forEach(function (pcs) {
                if (pcs.code === "PUBLIC") $scope.groupContactModal.group_contact_scope_id = pcs.id;
            });
        }
    });

    Restangular.all('GroupsContactsTypes').getList().then(function (groupsContactsTypes) {

        $scope.groupsContactsTypes = groupsContactsTypes;
        //Seleccionamos el correspondiente.
        if ($scope.groupContactModal != null) {
            $scope.groupsContactsTypes.forEach(function (pct) {
                if (pct.id === $scope.groupContactModal.group_contact_type_id) $scope.groupContactModal.FK_groups_contacts_groups_contacts_types.selected = pct;
            });
        }
    });

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.saveGroupContact = function () {
        //Devolvemos el control al principal
        $scope.groupContactModal.FK_groups_contacts_groups_contacts_scopes = _.find($scope.groupsContactsScopes, function (scope) { return scope.id == $scope.groupContactModal.group_contact_scope_id; });

        $uibModalInstance.close({ edited: $scope.groupContactModal, origin: $scope.groupContactOrigin });

    };//save


}])

.controller("GroupAddressModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'groupAddress', function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, groupAddress) {

    $scope.allowWrite = LoginService.permissionExist("GROUPS_WRITE");
    $scope.groupAddressModal = (!angular.isUndefined(groupAddress) ? angular.copy(groupAddress) : {});
    $scope.groupAddressOrigin = (!angular.isUndefined(groupAddress) ? groupAddress : {});

    //Groups_contacts_scopes y tl
    Restangular.all('GroupsAddressScopes').getList().then(function (groupsAddressessScopes) {

        $scope.groupsAddressessScopes = groupsAddressessScopes;
        //Seleccionamos el correspondiente.
        if ($scope.groupAddressModal !== null && angular.isUndefined($scope.groupAddressModal.group_address_scope_id)) {
            $scope.groupsAddressessScopes.forEach(function (pcs) {
                if (pcs.code === "PUBLIC") $scope.groupAddressModal.group_address_scope_id = pcs.id;
            });
        }
    });

    Restangular.all('Countries').getList().then(function (countries) {

        $scope.countries = countries;
        //Seleccionamos el correspondiente.
        $scope.defaultCountry = $scope.countries.find(country => country.code === 'ES');
        if ($scope.groupAddressModal !== null) {
            $scope.countries.forEach(function (pct) {
                if (pct.id == $scope.groupAddressModal.country_id) $scope.groupAddressModal.FK_groups_addresses_countries.selected = pct;
            });
        }

    });

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.saveGroupAddress = function () {
        // Devolvemos el control al principal
        $scope.groupAddressModal.FK_groups_addresses_groups_addresses_scopes = _.find($scope.groupsAddressessScopes, function (scope) { return scope.id == $scope.groupAddressModal.group_address_scope_id; });

        $uibModalInstance.close({ edited: $scope.groupAddressModal, origin: $scope.groupAddressOrigin });

    };

    // saveGroupAddress


}])

    .controller("PositionMailModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'position','position_email', function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, position, position_email) {

        $scope.allowWrite = LoginService.permissionExist("GROUPS_WRITE");

        if (position_email != null) {
            $scope.position_mail = position_email;
        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.savePositionMail = function () {

            if ($scope.position_mail.id != null) {
                $scope.position_mail.put().then(function (result) {
                    $uibModalInstance.close();
                });
            } else {
                $scope.position_mail.position_id = position.id;
                if (!angular.isUndefined(position.id)) {
                    Restangular.all('PositionsMails').post($scope.position_mail).then(function (result) {
                        $uibModalInstance.close();
                    })
                } else {
                    $uibModalInstance.close({ edited: $scope.position_mail });
                }
            }
        };

        $scope.deletePositionMail = function () {
            Restangular.one('PositionsMails', position_email.id).remove().then(function () {
                $uibModalInstance.close();
            });
        }

    }])

.controller("PositionAddressModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'positionAddress', function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, positionAddress) {

    $scope.allowWrite = LoginService.permissionExist("GROUPS_WRITE");
    $scope.positionAddressModal = (!angular.isUndefined(positionAddress) ? angular.copy(positionAddress) : {});
    $scope.positionAddressOrigin = (!angular.isUndefined(positionAddress) ? positionAddress : {});

    //Positions_contacts_scopes y tl
    Restangular.all('PositionsAddressScopes').getList().then(function (positionsAddressessScopes) {

        $scope.positionsAddressessScopes = positionsAddressessScopes;
        //Seleccionamos el correspondiente.

        if ($scope.positionAddressModal !== null && angular.isUndefined($scope.positionAddressModal.position_address_scope_id)) {
            $scope.positionsAddressessScopes.forEach(function (pcs) {
                if (pcs.code === "PUBLIC") $scope.positionAddressModal.position_address_scope_id = pcs.id;
            });
        }

    });

    Restangular.all('Countries').getList().then(function (countries) {

        $scope.countries = countries;
        //valor de $scope.countries donde el code es 'ES'
        var defaultCountry = $scope.countries.find(country => country.code === 'ES');

        //Seleccionamos el correspondiente.
        if ($scope.positionAddressModal != null) {
            $scope.positionAddressModal.FK_positions_addresses_countries = { selected: defaultCountry };
            $scope.countries.forEach(function (pct) {
                if (pct.id == $scope.positionAddressModal.country_id) $scope.positionAddressModal.FK_positions_addresses_countries.selected = pct;
            });
        }

    });

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.savePositionAddress = function () {

    // Devolvemos el control al principal

        $scope.positionAddressModal.FK_positions_addresses_positions_addresses_scopes = _.find($scope.positionsAddressessScopes, function (scope) { return scope.id == $scope.positionAddressModal.position_address_scope_id; });

        $uibModalInstance.close({ edited: $scope.positionAddressModal, origin: $scope.positionAddressOrigin });

    };

    // savePositionAddress


}])

.controller("PositionContactModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'positionContactInfo', 'logService',
    function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, positionContactInfo, logService) {

    $scope.allowWrite = LoginService.permissionExist("GROUPS_WRITE");
    $scope.positionContactModal = (!angular.isUndefined(positionContactInfo) ? angular.copy(positionContactInfo) : {});
    $scope.positionContactOrigin = (!angular.isUndefined(positionContactInfo) ? positionContactInfo : {});

    logService.debug(positionContactInfo);

    //Positions_contacts_scopes y tl
    Restangular.all('PositionsContactsScopes').getList().then(function (positionsContactsScopes) {

        $scope.positionsContactsScopes = positionsContactsScopes;
        //Seleccionamos el correspondiente.
        if ($scope.positionContactModal !== null && angular.isUndefined($scope.positionContactModal.position_contact_scope_id)) {
            $scope.positionsContactsScopes.forEach(function (pcs) {
                if (pcs.code === "PUBLIC") $scope.positionContactModal.position_contact_scope_id = pcs.id;
            });
        }
    });

    Restangular.all('PositionsContactsTypes').getList().then(function (positionsContactsTypes) {

        $scope.positionsContactsTypes = positionsContactsTypes;
        //Seleccionamos el correspondiente.
        if ($scope.positionContactModal != null) {
            $scope.positionsContactsTypes.forEach(function (pct) {
                if (pct.id == $scope.positionContactModal.position_contact_type_id) $scope.positionContactModal.FK_positions_contacts_positions_contacts_types.selected = pct;
            });
        }
    });

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.savePositionContact = function () {
        //Devolvemos el control al principal
        $scope.positionContactModal.FK_positions_contacts_positions_contacts_scopes = _.find($scope.positionsContactsScopes, function (scope) { return scope.id == $scope.positionContactModal.position_contact_scope_id; });

        $uibModalInstance.close({ edited: $scope.positionContactModal, origin: $scope.positionContactOrigin });

    };//save


}])

.controller("GroupGroupModalCtrl", ['$q', 'LoginService', '$scope', '$uibModalInstance', 'Restangular', 'parent_list','allow_select_multple', '$filter', '$timeout', '$stateParams', 'treeService','show_color', 'group_type', 'logService',
    function ($q, LoginService, $scope, $uibModalInstance, Restangular, parent_list, allow_select_multple, $filter, $timeout, $stateParams, treeService, show_color, group_type, logService) {

    logService.debug(`group_type = ${group_type}`);

        $scope.allowWrite = LoginService.permissionExist("GROUPS_WRITE");

            $scope.newParents = parent_list;
            
            $scope.newParentsClone = angular.copy(parent_list);
            logService.debug($scope.newParentsClone);

            $scope.show_color = show_color;


    $scope.search = {};

    $scope.gridDesciendeDeBuscadorOptions = {
        pdfTitle: $filter('translate')('groups.desciende_de'),
        exporterMenuCsv: true,
        enableGridMenu: true,
        showTreeExpandNoChildren: false,
        paginationPageSizes: [50, 200, 500],
        paginationPageSize: 50,
        enableSelectAll: false,
        onRegisterApi: function (gridApi) {
            this.gridApi = gridApi;
        },
        exporterFieldCallback: function (grid, row, col, value) {
            if (col.name == 'customName') {
                return row.entity.customNamePDF;
            } else {
                return value;
            }

        },
        columnDefs: [
            { name: 'id', visible: false, exporterSuppressExport: true },
            {
                name: 'customName', displayName: $filter('translate')('groups.name'), enableFiltering: false,
                enableHiding: false, cellTemplate: '<div ng-bind-html="row.entity[col.field] | to_trusted"></div>'

            },
            {
                visible: allow_select_multple,  name: 'is_parent', displayName: $filter('translate')('groups.is_parent'), enableFiltering: false, width: 100,
                enableHiding: false, enableColumnMenu: false, cellTemplate: "<div class=\"ui-grid-cell-contents\" style=\"padding-top: 3px;\">" +
                    "<input icheck  type=\"checkbox\" ng-model=\"row.entity.is_parent\" ng-disabled=\"!grid.appScope.allowWrite\" ng-change=\"grid.appScope.check(row.entity)\"></div>",
            }, {
                visible: (allow_select_multple ? false : true), name: 'is_parent2', displayName: $filter('translate')('groups.is_parent'), enableFiltering: false, width: 100,
                enableHiding: false, enableColumnMenu: false, cellTemplate: "<div class=\"ui-grid-cell-contents\" style=\"padding-top: 3px;\">" +
                    "<input icheck type=\"radio\" name=\"groupId\" ng-model=\"groupId\" value=\"row.entity.id\" ng-disabled=\"!grid.appScope.allowWrite\" ng-change=\"grid.appScope.checkSingle(row.entity)\"></div>",
            }
        ],
        getData: function (options) {
            var deferred = $q.defer();
            options.group_id = $stateParams.id;
            options.customName = $scope.search.name;
            options.group_type = group_type;


            Restangular.all('Groups').getList(options).then(function (results) {
                var filledList = _.map(results, function (group) {
                    group.is_parent = _.filter($scope.newParentsClone, function (relation) {
                        return relation.parent_group_id == group.id;
                    }).length > 0;
                    return group;
                });
                var data = treeService.groups(filledList, null);
                data.totalRows = results.totalRows;
                deferred.resolve(data);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }
    };

    $scope.searchGroups = function () {
        if ($scope.hasSearched) {
            $scope.gridDesciendeDeBuscadorOptions.loadData(false);
        }
        $scope.hasSearched = true;

    };

    /*
     * Función llamada al hacer click
     */
    $scope.check = function (group) {

        if (group.is_parent) {
            $scope.newParentsClone.push({
                parent_group_id: group.id,
                child_group_id: $stateParams.id,
                color: group.color
            });
        }
        else {
            $scope.newParentsClone = _.filter($scope.newParentsClone, function (relation) { return relation.parent_group_id != group.id; });
        }
        if ($scope.newParentsClone.length > 1) $scope.search.apply_parent_color = false;

   };

     /*
     * Función llamada al hacer click cuando es un radio button.
     */
    $scope.checkSingle = function (group) {
        $scope.newParentsClone = [];
        logService.debug(group);
        logService.debug($scope.newParentsClone);
        $scope.newParentsClone.push({
            parent_group_id: group.id
        });
    };

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.saveGroupsGroups = function () {
        //Devolvemos el control al principal
        
        $uibModalInstance.close({ parents_clone: $scope.newParentsClone, apply_parent_color: $scope.search.apply_parent_color });

    };//savePositionAddress

    /*
     * Ponemos foco en el buscador
     */
    $timeout(function () {
        angular.element("#name").focus();

    }, 100);
}])

.controller("SearchPersonsModalCtrl", ['gridService', '$timeout', 'LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', '$uibModal', 'options', '$rootScope', 'logService',
    function (gridService, $timeout, LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, $uibModal, options, $rootScope, logService) {

    $scope.showError = false;
    $scope.selectedRows = [];
    $scope.options = options;
    $scope.showResults = false;
    $scope.personPositionModal = {};
    $scope.personPositionOrigin = {};
    $scope.personPositionModal.persons_groups = {};
    $scope.personPositionModal.FK_positions_groups = null;
    $scope.eventFilter = {
        name: "",
        surname: "",
        lastname: "",
        position: "",
        state: "",
        listPositionsIds: [],
        is_inactive: false
    };



    $scope.parsePersonType = function (person_type) {

        logService.debug(person_type);
        var result = "";

        if (person_type == "authority") {

            result = $filter('translate')('persons.title');

        } if (person_type === "anonymous") {

            result = $filter('translate')('persons.title_anonymous');

        } else if (person_type === "imported") {

            result = $filter('translate')('persons.title_imported');

        } else if (person_type === "enrolled") {

            result = $filter('translate')('inscriptions_forms.inscripted');

        }

        return result;
    };

    if ($scope.personPositionModal.position_order == 0) $scope.personPositionModal.position_order = null;
       
    //cargamos los grupos de información
    var optionsPIG = { entity_type: "persons" };
    Restangular.all('InformationsGroups').getList(optionsPIG).then(function (personsInformationGroups) {
        $scope.personsInformationGroups = personsInformationGroups.filter(m => m.use_in_search == true);
        $scope.personsInformationGroups.forEach(function (pig) {
            if (pig.configuration != "") pig.configuration = JSON.parse(pig.configuration);
        });

        $scope.checkboxSimpleOptions = [
            { option: null, label: $filter('translate')('informations.all'), checked: true },
            { option: true, label: $filter('translate')('events.staff.yes'), checked: false },
            { option: false, label: $filter('translate')('events.staff.no'), checked: false }
        ];
    });
        //Custom function.  return null values instead of undefined
    function isDefinedAndNotNull(val) {
        return angular.isDefined(val) && val !== null;
    };

    $scope.searchPersons = function () {
        $scope.selectedRows = [];
            $scope.showResults = true;
            if (angular.isDefined($scope.gridPersonsOptions)) {
                $scope.gridPersonsOptions.loadData(false);
            } else {
                $scope.gridPersonsOptions = {
                    exporterMenuCsv: false,
                    enableFiltering: false,
                    enableGridMenu: true,
                    paginationPageSizes: [20, 40, 60],
                    pdfTitle: $rootScope.title,
                    paginationPageSize: 20,
                    exporterOlderExcelCompatibility: true,
                    rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                        this.gridApi.core.on.rowsRendered($scope, callbackFunctionItemChange);
                        this.gridApi.selection.on.rowSelectionChanged($scope, callbackFunctionRowSelected);
                        this.gridApi.selection.on.rowSelectionChangedBatch($scope, callbackFunctionRowSelected);
                    },
                    columnDefs: [
                        { name: 'id', visible: false, exporterSuppressExport: true, width: 80 },
                        { name: 'id_ext', visible: false, exporterSuppressExport: true, width: 80 },
                        {
                            name: 'is_active', displayName: " ", visible: true, exporterSuppressExport: true, width: 30, enableHiding: false,
                            cellTemplate: "<div class=\"ui-grid-cell-contents\" style=\"text-align: center;\">" +
                                "<span ng-if=\"!row.entity.is_active\" class=\"label label-danger\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                                "<span ng-if=\"row.entity.is_active\" class=\"label label-primary\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                                "</div>"
                        },
                        {
                            field: 'image_id',
                            enableSorting: false,
                            visible: $stateParams.person_type != 'anonymous',
                            width: 50,
                            enableFiltering: false,
                            customFormatFn: function (value) {
                                if (value != null) {
                                    var img = {
                                        image: value,
                                        width: 30
                                    };
                                    return img;
                                } else {
                                    return "";
                                }
                            },
                            displayName: $filter('translate')('persons_reports.photo'),
                            cellTemplate: "<div style='height: 28px; overflow: hidden;'><img width=\"28px\" ng-show=\"grid.getCellValue(row, col)\" ng-src=\"/api/Image/GetImageBmp?id={{row.entity.image_id}}&maxW=28&maxH2=28\" style=\"margin-left:5px;margin-top:0px\" lazy-src></div>"
                        },
                        { name: 'name', displayName: $filter('translate')('persons.name'), enableFiltering: true, enableHiding: false, minWidth: 80, maxWidth: 150 },
                        { name: 'surname', displayName: $filter('translate')('persons.surname'), enableFiltering: true, enableHiding: true, minWidth: 80, maxWidth: 150 },
                        { name: 'lastname', displayName: $filter('translate')('persons.lastname'), enableFiltering: true, enableHiding: true, minWidth: 60, maxWidth: 150 },
                        {
                            name: 'person_type', displayName: $filter('translate')('persons.type'), enableFiltering: true,
                            cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{grid.appScope.parsePersonType(row.entity.person_type)}}</div>'
                        },
                        {
                            name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                                { title: $filter('translate')('persons.edit'), action: 'ng-if="row.entity.is_active || row.entity.person_type==\'anonymous\' || row.entity.person_type==\'imported\'" ui-sref="persons.edit({person_type: row.entity.person_type, id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                                { title: $filter('translate')('persons.edit'), action: 'ng-if="!row.entity.is_active" ui-sref="persons.edit({person_type: \'inactive\', id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                                { title: $filter('translate')('persons.button_delete'), action: 'ng-click="grid.appScope.DeleteDialog(row.entity.id,row.entity.name, row.entity.surname);" ng-if="grid.appScope.allowWrite && (grid.appScope.allowDelete || (grid.appScope.allowDiscard && (grid.appScope.person_type==\'anonymous\' || grid.appScope.person_type==\'imported\' )))" ', cssIconClass: "fa fa-remove" }
                            ], { cssClass: "pull-right" })
                        },
                    ],
                    getData: function (options) {

                        // options.person_type = $scope.person_type;

                        options.is_active = true;

                        if ($scope.eventFilter.name != "") options.name = $scope.eventFilter.name;
                        if ($scope.eventFilter.surname != "") options.surname = $scope.eventFilter.surname;
                        if ($scope.eventFilter.lastname != "") options.lastname = $scope.eventFilter.lastname;
                        if ($scope.eventFilter.position != "") options.position_name = $scope.eventFilter.position;
                        if ($scope.eventFilter.state != "") options.state = $scope.eventFilter.state;
                        if ($scope.eventFilter.listPositionsIds.length > 0) options.listPositionsIds = $scope.eventFilter.listPositionsIds;

                        var pigs = "";
                        for (var key in $scope.eventFilter.pigs) {
                            if (typeof $scope.eventFilter.pigs[key] != "undefined" && $scope.eventFilter.pigs[key] != "") {
                                if (typeof ($scope.eventFilter.pigs[key]) == "object") {
                                    //estamos en el selector simple.
                                   // pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.eventFilter.pigs[key].checked;
                                    var infoFilter = $scope.personsInformationGroups.filter(function (el) { return el.id == key; });
                                    if (infoFilter.length == 1) {
                                        if (infoFilter[0].type == "datetime") {
                                            if ($scope.eventFilter.pigs[key] != null) pigs += (pigs != "" ? "#" : "") + key + "=>" + new Date($scope.eventFilter.pigs[key]).toISOString();
                                        } else if (infoFilter[0].type == "checkboxSimple") {
                                            if ($scope.eventFilter.pigs[key].checked != "") pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.eventFilter.pigs[key].checked;
                                        } else {
                                            pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.eventFilter.pigs[key];
                                        }
                                    }
                                } else {
                                    pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.eventFilter.pigs[key];
                                }
                            }
                        }
                        options.pigs = pigs;

                        var deferred = $q.defer();

                        Restangular.all('Persons/GetAllPersonsFiltered').post(options).then(function (results) {

                            var data = results.rows;
                            var personsIds = [];

                            angular.forEach(data, function (dataR) {
                                if (personsIds.indexOf(dataR.id) < 0) {
                                    personsIds.push(dataR.id);
                                }
                            });

                            //Obtenemos sus imágenes
                            if (personsIds.length > 0 && options._pageSize != null) { //para que no casque si quieren imprimir todo...
                                $http({
                                    method: 'post',
                                    url: (window as any).CONFIG.api_url + 'Persons/ImagesSmall',
                                    params: { ids: personsIds }
                                }).then(function (resultsImage, status, headers, config) {
                                    angular.forEach(data, function (person) {
                                        for (var i = 0; i < resultsImage.data.length; i++) {
                                            if (person.id == resultsImage.data[i].person_id) {
                                                person.image_small = resultsImage.data[i].image_small;
                                                break;
                                            }
                                        }
                                    });
                                });
                            }

                            data.totalRows = results.totalRows;
                            $scope.totalRows = results.totalRows;
                            $scope.persons = data;
                            deferred.resolve(data);
                        });
                        return deferred.promise;
                    }
                };
            }
    };

    let callbackFunctionRowSelected = function (row, evt) {
        let addAll = row.length > 1;

        if (!addAll) {
            //buscamos si ya existe la persona añadida
            var index = $scope.selectedRows.map(function (e) { return e.id; }).indexOf(row.entity.id);
            if (index < 0) {
                if (row.isSelected) {
                    $scope.selectedRows.push({ id: row.entity.id, positionId: [row.entity.positionId] });
                } else {
                    $scope.selectedRows.splice(index, 1);
                }
            } else {
                //ya existe, si is seleccionado, lo añadimos y sino lo borramos.
                if (row.isSelected) {
                    $scope.selectedRows.map(function (e) { if (e.id == row.entity.id) e.positionId.push(row.entity.positionId) });
                } else {

                    for (let i = 0; i < $scope.selectedRows.length; i++) {
                        if ($scope.selectedRows[i].id == row.entity.id) {

                            //var indexPosition = $scope.selectedRows[i].positionId.map(function (e) { return e.positionId; }).indexOf(row.entity.positionId);
                            var indexPosition = $scope.selectedRows[i].positionId.indexOf(row.entity.positionId);
                            var lengthOfPositions = $scope.selectedRows[i].positionId.map(function (e) { return e.positionId; }).length;
                            logService.debug(row.entity.positionId + " " + indexPosition);
                        }
                    }

                    $scope.selectedRows.map(function (e) { if (e.id == row.entity.id) e.positionId.splice(indexPosition, 1) });
                    if (lengthOfPositions == 1) {
                        //eliminamos a la persona
                        var index = $scope.selectedRows.map(function (e) { return e.id; }).indexOf(row.entity.id);
                        $scope.selectedRows.splice(index, 1);
                    }
                }
            }
        } else {
            if (row[0].isSelected) {
                // se ha seleccionado todo.
                $scope.selectedRows = [];
                for (let i = 0; i < $scope.gridPersonsOptions.gridApi.grid.options.totalItems; i++) { $scope.selectedRows.push(i); };
            } else {
                $scope.selectedRows = [];
            }
        }
    };

    let callbackFunctionItemChange = function () {
        $timeout(function () {
            for (var i = 0; i < $scope.gridPersonsOptions.data.length; i++) {
                var row = $scope.gridPersonsOptions.data[i];
                for (var select = 0; select < $scope.selectedRows.length; select++) {
                    let selected = $scope.selectedRows[select];
                    if (row.id == selected.id) {
                        $scope.gridPersonsOptions.gridApi.selection.toggleRowSelection(row);
                        break
                    }
                };
            }
        }, 350);
        // lo pongo así porque sino falla la primera vez
    };

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.addGuests = function (continueOption) {

        var addAll = $scope.gridPersonsOptions.gridApi.selection.getSelectAllState();
        var ids = new Array();
        if (addAll) {
            let options: any = {};
            options.person_type = $scope.person_type;
            options.is_active = true;

            if ($scope.eventFilter.name != "") options.name = $scope.eventFilter.name;
            if ($scope.eventFilter.surname != "") options.surname = $scope.eventFilter.surname;
            if ($scope.eventFilter.lastname != "") options.lastname = $scope.eventFilter.lastname;
            if ($scope.eventFilter.position != "") options.position_name = $scope.eventFilter.position;
            if ($scope.eventFilter.state != "") options.state = $scope.eventFilter.state;
            if ($scope.eventFilter.listPositionsIds.length > 0) options.listPositionsIds = $scope.eventFilter.listPositionsIds;

            var pigs = "";
            for (var key in $scope.eventFilter.pigs) {
                if (typeof $scope.eventFilter.pigs[key] != "undefined" && $scope.eventFilter.pigs[key] != "") {
                    if (typeof ($scope.eventFilter.pigs[key]) == "object") {
                        //estamos en el selector simple.
                        pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.eventFilter.pigs[key].checked;
                    } else {
                        pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.eventFilter.pigs[key];
                    }
                }
            }

            options.pigs = pigs;

            Restangular.all('Persons/GetAllPersonsFiltered').post(options).then(function (results) {
                var data = results.rows;
                angular.forEach(data, function (dataR) {
                    if (ids.indexOf(dataR.id) < 0) {
                        //personsIds.push(dataR.id);
                        ids.push(dataR.id);
                    }
                });
                $uibModalInstance.close(ids);
            });
        } else {
            let selectedRows = $scope.gridPersonsOptions.gridApi.selection.getSelectedRows();;
            angular.forEach(selectedRows, function (row) {
                ids.push(row.id);
            });
            if (ids.length > 0) {
                //if (continueOption == 0) {
                    $uibModalInstance.close(ids);
                //} else {
                //    if (!$scope.$$phase) $scope.$apply();
                //    $scope.$parent.loadGuests();
                //}
            }
        }
            
    };//savePersonPosition

    $scope.searchGroup = function () {

            let $modalInstance = $uibModal.open({
                animation: true,
                template: SearchGroupModalView,
                size: "lg",
                controller: "SearchGroupModalCtrl",
                resolve: {
                    preselect: function () {
                        return false;  //para preseleccionar los grupos ya buscados
                    },
                    event_id: function () {
                        return 0;
                    },
                    is_filter: function () {
                        return false;
                    },
                    listGroupsIds: function () {
                        return [];
                    },
                    listPositionsIds: function () {
                        return [];
                    }
                }
            });
            //Response del modal
            $modalInstance.result.then(function (groups) {
                if (groups.listPositions.length > 0) {
                    $scope.eventFilter.listPositionsIds = groups.listPositions;
                    $scope.searchPersons();
                }
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
                if (!$scope.$$phase) $scope.$apply();
            });
        };

    $scope.clearGroupFilter = function () {
        $scope.eventFilter = {
            name: "",
            surname: "",
            lastname: "",
            position: "",
            state: "",
            listPositionsIds: []
        };

        $scope.searchPersons();
    };

}])
    .controller("GroupsDeleteModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$uibModal', '$rootScope', '$state', function ($scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $uibModal, $rootScope, $state) {

        $scope.deleteOptions = { deleteDescendants: false };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.onAccept = function () {
                $scope.group.remove($scope.deleteOptions).then(function () {
                    toastr.success($filter('translate')('groups.delete_ok'));
                    $state.go("groups.list");
                }, function (error) {
                    toastr.error(error.data.ExceptionMessage);
                }
                );
        };

    }]);

